import { Scene, Engine, Color, ExcaliburGraphicsContext } from 'excalibur';
import { Label, Font, vec } from 'excalibur';
import { Mortar } from './Mortar';
import { Mountain } from './Mountain';
import { controller } from '../../shared/controls/controller';
import { leftKeyboard } from '../../shared/controls/leftKeyboard';
import { rightKeyboard } from '../../shared/controls/rightKeyboard';

import { Actor, CollisionType, Shape } from 'excalibur';

export class MortarsScene extends Scene {
    private player1!: Mortar;
    private player2!: Mortar;
    private mountain!: Mountain;
    private controller1!: ReturnType<typeof controller> | ReturnType<typeof leftKeyboard>;
    private controller2!: ReturnType<typeof controller> | ReturnType<typeof rightKeyboard>;
    private infoLabel!: Label;

    onInitialize(engine: Engine) {
        // Create mountain in the center
        // Place mountain so its base is at player level, and its peak is near the top
        const mountainBaseY = engine.drawHeight - 30; // same as player y
        const mountainHeight = engine.drawHeight - 500; // leave space at top
        this.mountain = new Mountain(engine.halfDrawWidth, mountainBaseY, engine.drawWidth * 0.7, mountainHeight);
        this.add(this.mountain);

        // Add flat green ground at the bottom
        const groundHeight = 40;
        const ground = new Actor({
            x: engine.drawWidth / 2,
            y: engine.drawHeight - groundHeight / 2,
            width: engine.drawWidth,
            height: groundHeight,
            color: Color.Green,
            collisionType: CollisionType.Fixed,
            anchor: vec(0.5, 0.5)
        });
        ground.body.collisionType = CollisionType.Fixed;
        ground.collider.set(Shape.Box(engine.drawWidth, groundHeight));
        this.add(ground);

        // Setup controllers for both players
        const gamepad1 = engine.input.gamepads.at(0);
        this.controller1 = gamepad1.connected ? controller(gamepad1) : leftKeyboard(engine.input.keyboard);
        const gamepad2 = engine.input.gamepads.at(1);
        this.controller2 = gamepad2.connected ? controller(gamepad2) : rightKeyboard(engine.input.keyboard);

        // Create players
        this.player1 = new Mortar({ x: 300, y: engine.drawHeight - 100, color: Color.Red, facing: 'right', mortarController: this.controller1 });
        this.player2 = new Mortar({ x: engine.drawWidth - 300, y: engine.drawHeight - 100, color: Color.Blue, facing: 'left', mortarController: this.controller2 });
        this.add(this.player1);
        this.add(this.player2);
        // Info label for player angle/power
        this.infoLabel = new Label({
            text: '',
            pos: vec(40, 60),
            font: new Font({ size: 32, family: 'monospace', color: Color.White })
        });
        this.add(this.infoLabel);
    }

    onPreUpdate(engine: Engine, delta: number) {
        this.infoLabel.text = `Player 1  Angle ${this.player1.angle.toFixed(1)}°\nPlayer 2  Angle ${this.player2.angle.toFixed(1)}°`;
        this.player1.handleRotationAndFiring(delta);
        this.player2.handleRotationAndFiring(delta);
    }

    onPostDraw(ctx: ExcaliburGraphicsContext, elapsedMs: number) {
        // No overlays needed; aiming is shown by the mortar actor's line
    }
}
